import { createContext, contextProvider, contextProvided } from '@lit-labs/context';
export const authContext = createContext('auth');
export { contextProvider as provider, contextProvided as consumer };
//# sourceMappingURL=context.js.map